<template>
  <div class="dashboard" :style="{ backgroundImage: `url(/backimag2.png)` }">
    <div class="grid-container">
      <!-- 第1行：高度比例 1 -->
      <div class="grid-item header" style="grid-column: 1 / 4; background: none; border: none;">
        <div class="header-content">
          <!-- 标题居中 -->
          <p class="title">进销存平台</p>

          <!-- 最右边图标区域 -->
          <div class="header-icons">
            <button class="icon-btn" title="返回">
              <i class="el-icon-refresh-left" @click="handleBack"></i>
            </button>
            <button class="icon-btn" v-if="checkPrower('showbigxs')" @click="openDialog" title="切换盈利大屏">
              <i class="el-icon-data-analysis"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- 第2行：高度比例 3 -->
      <div class="grid-item" id="mychartA"
      ></div>
      <div class="grid-item main" style="grid-row: span 2;" id="mychartB">主要内容区 / 大图表 (中)</div>
      <div class="grid-item" id="mychartC">区域 C (右)</div>

      <!-- 第3行：高度比例 3 -->
      <div class="grid-item" id="mychartD">区域 D</div>
      <div class="grid-item" id="mychartF">区域 F</div>

      <!-- 第4行：高度比例 3 -->
      <div class="grid-item" id="mychartG"></div>
      <div class="grid-item" id="mychartH">区域 H</div>
      <div class="grid-item" id="mychartI">区域 I / 底部状态</div>
    </div>

    <!-- Dialog（切换弹窗） -->
    <div v-if="showDialog" class="dialog-overlay" @click="closeDialog">
      <div class="dialog-content" @click.stop>
        <h3>切换销售以及盈利大屏</h3>
        <input type="password"/>
        <div class="dialog-actions">
          <button @click="closeDialog">取消</button>
          <button @click="closeDialog">确认切换</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import chinaGeoJson from '@/views/showbig/map.json'
export default {
  data() {
    return {
      showDialog: false,
      mychartsA: [],
      mychartsB: [],
      mychartsC: [],
      mychartsD: [],
      mychartsF: [],
      mychartsG: [],
      mychartsH: [],
      mychartsI: [],
    }
  },
  mounted() {
    this.getList();
    //左侧3个
    this.initEchartsA();
    this.initEchartsD();
    this.initEchartsG();
    this.initEchartsH();
    this.initEchartsB();
    this.initEchartsI();
    this.initEchartsC();
    this.initEchartsF();
  },

  methods: {
    checkPrower(permission) {
      const qx = localStorage.getItem('qx');
      return qx && qx.includes(permission);
    },
    openDialog() {
      this.showDialog = true;
    },
    handleBack() {
      this.$emit("bigshowfh", true)
    },
    closeDialog() {
      this.$emit("bigshowxsjs", true)

    },
    getList() {
      this.loading = true;
      this.$request.postHttp({
        url: "/basic/ProductList",
        data: JSON.stringify(this.queryParams),
        success: (data) => {
          this.tableData = data.data.records
          this.total = data.data.total
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
      this.loading = false;
    },
    initEchartsA() {
      let titlename = '入库情况'
      let myData4 = [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月",
      ];
      let jccs = [30, 28, 35, 32, 24, 28, 34, 32, 29, 30, 34, 32];
      let bls = [8, 3, 6, 9, 5, 2, 3, 4, 5, 6, 7, 2];
      let color = ['rgba(232,127,127,0.8)', 'rgba(255,190,115,0.8)']
      let option = {

        title: {
          text: titlename,
          textStyle: {
            align: "center",
            color: "#fff",
            fontSize: 15,
          },
          top: "2%",
          left: "center",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(0, 255, 233,0)",
                  },
                  {
                    offset: 0.5,
                    color: "rgba(255, 255, 255,1)",
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 255, 233,0)",
                  },
                ],
                global: false,
              },
            },
          },
          textStyle: {
            color: "#fff",
          },
          backgroundColor: "rgba(17,95,182,0.5)", //设置背景颜色
          borderColor: "rgba(255, 255, 255, .8)",
          confine: true,
          formatter: "{b}<br>{a}：{c}个<br>{a1}：{c1}个",
        },
        legend: {
          // icon: "rect",
          itemWidth: 14,
          itemHeight: 6,
          itemGap: 20,
          right: "8%",
          top: "4%",
          textStyle: {
            fontSize: "14px",
            color: "#fff",
          },
          data: ["怀柔库", "南京库"],
        },
        grid: {
          top: "14%",
          left: "2%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: myData4,
          axisLabel: {
            color: "#fff",
            interval: 0,
            fontSize: "14px",
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(127, 214, 255, .4)",
            },
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          boundaryGap: false,
        },
        yAxis: {
          type: "value",
          name: "数量",
          nameTextStyle: {
            color: "#fff",
            fontSize: "14px",
            align: "center",
            padding: [0, 20, 0, 0],
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "rgba(127, 214, 255, .4)",
            },
          },
          min: 0,
          axisLabel: {
            show: true,
            color: "#fff",
            fontSize: "14px",
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 0.8,
              color: "rgba(127, 214, 255, .4)",
              type: "dashed",
            },
          },
        },
        series: [
          {
            name: "怀柔库",
            type: "line",
            showSymbol: false,
            smooth: false,
            // symbolSize: 8,
            lineStyle: {
              normal: {
                color: color[0],
              },
            },
            itemStyle: {
              color: color[0],
              borderColor: color[0],
              borderWidth: 2,
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: color[0],
                      },
                      {
                        offset: 0.2,
                        color: "rgba(25, 224, 121, 0)",
                      },
                    ],
                    false
                ),
              },
            },
            data: jccs,
          },
          {
            name: "南京库",
            type: "line",
            showSymbol: false,
            smooth: false,
            // symbolSize: 8,
            lineStyle: {
              normal: {
                type: "dotted", //'dotted'虚线 'solid'实线
                color: color[1],
              },
            },
            itemStyle: {
              color: color[1],
              borderColor: color[1],
              borderWidth: 2,
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: color[1],
                      },
                      {
                        offset: 0.2,
                        color: "rgba(51, 162, 240, 0)",
                      },
                    ],
                    false
                ),
              },
            },
            data: bls,
          },
        ],
      };
      const echartsdom = document.getElementById('mychartA')
      this.mychartsA = echarts.init(echartsdom)

      this.mychartsA.setOption(option, true);// 渲染页面
      window.addEventListener("resize", () => {
        this.mychartsA.resize();
      });
    },
    initEchartsD() {
      let myData4 = [
        "1月",
        "2月",
        "3月",
        "4月"
      ];
      let color = ['rgba(102,255,0,0.8)', 'rgba(229,237,0,0.8)']
      let jccs = [200, 300, 500, 320];
      let bls = [120, 30, 200, 700];
      let titlename = '出库情况'
      let option = {

        title: {
          text: titlename,
          textStyle: {
            align: "center",
            color: "#fff",
            fontSize: 15,
          },
          top: "2%",
          left: "center",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(0, 255, 233,0)",
                  },
                  {
                    offset: 0.5,
                    color: "rgba(255, 255, 255,1)",
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 255, 233,0)",
                  },
                ],
                global: false,
              },
            },
          },
          textStyle: {
            color: "#fff",
          },
          backgroundColor: "rgba(17,95,182,0.5)", //设置背景颜色
          borderColor: "rgba(255, 255, 255, .8)",
          confine: true,
          formatter: "{b}<br>{a}：{c}个<br>{a1}：{c1}个",
        },
        legend: {
          // icon: "rect",
          itemWidth: 14,
          itemHeight: 6,
          itemGap: 20,
          right: "8%",
          top: "4%",
          textStyle: {
            fontSize: "14px",
            color: "#fff",
          },
          data: ["怀柔库", "南京库"],
        },
        grid: {
          top: "14%",
          left: "2%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: myData4,
          axisLabel: {
            color: "#fff",
            interval: 0,
            fontSize: "14px",
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(127, 214, 255, .4)",
            },
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          boundaryGap: false,
        },
        yAxis: {
          type: "value",
          name: "数量",
          nameTextStyle: {
            color: "#fff",
            fontSize: "14px",
            align: "center",
            padding: [0, 20, 0, 0],
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "rgba(127, 214, 255, .4)",
            },
          },
          min: 0,
          axisLabel: {
            show: true,
            color: "#fff",
            fontSize: "14px",
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 0.8,
              color: "rgba(127, 214, 255, .4)",
              type: "dashed",
            },
          },
        },
        series: [
          {
            name: "怀柔库",
            type: "line",
            showSymbol: false,
            smooth: false,
            // symbolSize: 8,
            lineStyle: {
              normal: {
                color: color[0],
              },
            },
            itemStyle: {
              color: color[0],
              borderColor: color[0],
              borderWidth: 2,
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: color[0],
                      },
                      {
                        offset: 0.2,
                        color: "rgba(25, 224, 121, 0)",
                      },
                    ],
                    false
                ),
              },
            },
            data: jccs,
          },
          {
            name: "南京库",
            type: "line",
            showSymbol: false,
            smooth: false,
            // symbolSize: 8,
            lineStyle: {
              normal: {
                type: "dotted", //'dotted'虚线 'solid'实线
                color: color[1],
              },
            },
            itemStyle: {
              color: color[1],
              borderColor: color[1],
              borderWidth: 2,
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: color[1],
                      },
                      {
                        offset: 0.2,
                        color: "rgba(51, 162, 240, 0)",
                      },
                    ],
                    false
                ),
              },
            },
            data: bls,
          },
        ],
      };
      const echartsdom = document.getElementById('mychartD')
      this.mychartsD = echarts.init(echartsdom)

      this.mychartsD.setOption(option, true);// 渲染页面
    },
    initEchartsG() {
      let titlename = '积货情况'
      let myData4 = [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月",
      ];
      let jccs = [30, 28, 35, 32, 24, 28, 34, 32, 29, 30, 34, 32];
      let bls = [8, 3, 6, 9, 5, 2, 3, 4, 5, 6, 7, 2];
      let color = ['rgba(0,128,255,0.8)', 'rgba(163,140,246,0.8)']
      let option = {

        title: {
          text: titlename,
          textStyle: {
            align: "center",
            color: "#fff",
            fontSize: 15,
          },
          top: "2%",
          left: "center",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(0, 255, 233,0)",
                  },
                  {
                    offset: 0.5,
                    color: "rgba(255, 255, 255,1)",
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 255, 233,0)",
                  },
                ],
                global: false,
              },
            },
          },
          textStyle: {
            color: "#fff",
          },
          backgroundColor: "rgba(17,95,182,0.5)", //设置背景颜色
          borderColor: "rgba(255, 255, 255, .8)",
          confine: true,
          formatter: "{b}<br>{a}：{c}个<br>{a1}：{c1}个",
        },
        legend: {
          // icon: "rect",
          itemWidth: 14,
          itemHeight: 6,
          itemGap: 20,
          right: "8%",
          top: "4%",
          textStyle: {
            fontSize: "14px",
            color: "#fff",
          },
          data: ["怀柔库", "南京库"],
        },
        grid: {
          top: "14%",
          left: "2%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: myData4,
          axisLabel: {
            color: "#fff",
            interval: 0,
            fontSize: "14px",
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(127, 214, 255, .4)",
            },
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          boundaryGap: false,
        },
        yAxis: {
          type: "value",
          name: "数量",
          nameTextStyle: {
            color: "#fff",
            fontSize: "14px",
            align: "center",
            padding: [0, 20, 0, 0],
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "rgba(127, 214, 255, .4)",
            },
          },
          min: 0,
          axisLabel: {
            show: true,
            color: "#fff",
            fontSize: "14px",
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 0.8,
              color: "rgba(127, 214, 255, .4)",
              type: "dashed",
            },
          },
        },
        series: [
          {
            name: "怀柔库",
            type: "line",
            showSymbol: false,
            smooth: false,
            // symbolSize: 8,
            lineStyle: {
              normal: {
                color: color[0],
              },
            },
            itemStyle: {
              color: color[0],
              borderColor: color[0],
              borderWidth: 2,
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: color[0],
                      },
                      {
                        offset: 0.2,
                        color: "rgba(25, 224, 121, 0)",
                      },
                    ],
                    false
                ),
              },
            },
            data: jccs,
          },
          {
            name: "南京库",
            type: "line",
            showSymbol: false,
            smooth: false,
            // symbolSize: 8,
            lineStyle: {
              normal: {
                type: "dotted", //'dotted'虚线 'solid'实线
                color: color[1],
              },
            },
            itemStyle: {
              color: color[1],
              borderColor: color[1],
              borderWidth: 2,
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: color[1],
                      },
                      {
                        offset: 0.2,
                        color: "rgba(51, 162, 240, 0)",
                      },
                    ],
                    false
                ),
              },
            },
            data: bls,
          },
        ],
      };
      const echartsdom = document.getElementById('mychartG')
      this.mychartsG = echarts.init(echartsdom)

      this.mychartsG.setOption(option, true);// 渲染页面
    },

    initEchartsH() {
      let titlename = '怀柔仓库-当前库存';
      var colorArray = [
        {
          top: "#ffa800", //黄
          bottom: "rgba(11,42,84,.3)",
        },
        {
          top: "#1ace4a", //绿
          bottom: "rgba(11,42,84, 0.3)",
        },
        {
          top: "#4bf3ff", //蓝
          bottom: "rgba(11,42,84,.3)",
        },
        {
          top: "#4f9aff", //深蓝
          bottom: "rgba(11,42,84,.3)",
        },
        {
          top: "#b250ff", //粉
          bottom: "rgba(11,42,84,.3)",
        },
      ];
      let option = {
        title: {
          text: titlename,           // 标题文本
          left: 'center',             // 水平居中
          top: '2%',                  // 距离顶部距离
          textStyle: {
            color: '#fff',            // 标题颜色
            fontSize: 15,             // 标题字体大小
            fontWeight: 'bold',       // 字体加粗
          },
        },


        tooltip: {
          show: true,
          formatter: "{b}: {c}个",
        },
        grid: {
          left: "8%",
          top: "15%",
          right: "5%",
          bottom: "8%",
          containLabel: true,
        },

        // Y轴配置
        yAxis: {
          type: "value",
          name: "数量",
          nameTextStyle: {
            color: "#fff",
            fontSize: 12,
          },
          show: true,
          position: "left",
          axisTick: {
            show: true,
            lineStyle: {
              color: "rgba(255,255,255,0.3)",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(255,255,255,0.3)",
            },
          },
          axisLabel: {
            show: true,
            color: "#fff",
            fontSize: 11,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(255,255,255,0.15)",
              type: "solid",
              width: 1,
            },
          },
          min: 0,
        },

        // X轴配置
        xAxis: [
          {
            type: "category",
            axisTick: {
              show: false,
              alignWithLabel: false,
              length: 5,
            },
            splitLine: {
              show: false,
            },
            inverse: "true",
            axisLine: {
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,0.3)",
              },
            },
            axisLabel: {
              show: true,
              color: "#fff",
              fontSize: 11,
              rotate: 0,
              interval: 0,
            },
            data: ["智卫枪机", "智卫球机", "智卫半球", "防爆球机", "59半球"],
          },
        ],

        series: [
          {
            name: "能耗值",
            type: "bar",
            label: {
              normal: {
                show: true,
                position: "top",
                formatter: "{c}",
                textStyle: {
                  color: "white",
                  fontSize: 12,
                  fontWeight: "bold",
                },
              },
            },
            itemStyle: {
              normal: {
                show: true,
                color: function (params) {
                  let num = colorArray.length;
                  return {
                    type: "linear",
                    x: 0, y: 0,
                    x2: 0, y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: colorArray[params.dataIndex % num].top,
                      },
                      {
                        offset: 1,
                        color: colorArray[params.dataIndex % num].bottom,
                      },
                    ],
                    globalCoord: false
                  };
                },
                // 设置圆角：[左上, 右上, 右下, 左下]
                // 这里设置上面两个角为圆角(20px)，下面两个角为直角(0)
                barBorderRadius: [20, 20, 0, 0],
                borderWidth: 0,
                borderColor: "#333",
              },
            },
            barWidth: 30,
            barGap: "30%",
            barCategoryGap: "40%",
            data: [60, 132, 89, 134, 60],
          },
        ],
      };

      const echartsdom = document.getElementById('mychartH')
      this.mychartsH = echarts.init(echartsdom)

      this.mychartsH.setOption(option, true);// 渲染页面
    },
    initEchartsI(){

       var scaleData = [
        {
          name: "z",
          value: 10,
        },
        {
          name: "n",
          value: 20,
        },
        {
          name: "x",
          value: 23,
        },
        {
          name: "d",
          value: 28,
        },
        {
          name: "b",
          value: 50,
        },

      ];
      var rich = {
        white: {
          color: "#fff",
          align: "center",
          fontWeight: "bold",
          padding: [3, 0],
        },
      };
      var placeHolderStyle = {
        normal: {
          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
          color: "rgba(0, 0, 0, 0)",
          borderColor: "rgba(0, 0, 0, 0)",
          borderWidth: 0,
        },
      };
      var data = [];
      var color1 = [
        "rgb(255, 153, 153)",
        "rgb(255, 176, 63)",
        "rgb(61, 186, 45)",
        "rgb(43, 166, 254)",
        "rgb(255,222,0)",
        "rgb(255,0,0)",
      ];

      for (var i = 0; i < scaleData.length; i++) {
        data.push(
            {
              value: scaleData[i].value,
              name: scaleData[i].name,
              itemStyle: {
                normal: {
                  borderWidth: 4,
                  shadowBlur: 30,
                  borderColor: color1[i],
                  shadowColor: color1[i],
                  color: color1[i],
                  opacity: 0.75,
                },
              },
            },
            {
              value: 2,
              name: "",
              itemStyle: placeHolderStyle,
            }
        );
      }
      var seriesObj = [
        {
          name: "",
          type: "pie",
          clockWise: false,
          radius: ['45%', '85%'],  // 内半径45%，外半径70%
          center: ['50%', '50%'],  // 中心点位置
          hoverAnimation: false,
          itemStyle: {
            normal: {
              label: {
                show: true,
                position: "inner",
                fontWeight: "bold",
                formatter: function (params) {
                  var percent = 0;
                  var total = 0;
                  for (var i = 0; i < scaleData.length; i++) {
                    total += scaleData[i].value;
                  }
                  percent = ((params.value / total) * 100).toFixed(0);
                  if (params.name !== "") {
                    return params.name + "\n{white|" + "占比" + percent + "%}";
                  } else {
                    return "";
                  }
                },
                rich: rich,
              },
              labelLine: {
                show: false,
              },
            },
          },
          data: data,
        },
      ];
     let option = {
        tooltip: {
          show: false,
        },
        legend: {
          show: false,
        },
        toolbox: {
          show: false,
        },
       title: {
         text: '112销售占比',           // 标题文本
         left: 'left',             // 水平居中
         top: '2%',                  // 距离顶部距离
         textStyle: {
           color: '#fff',            // 标题颜色
           fontSize: 15,             // 标题字体大小
           fontWeight: 'bold',       // 字体加粗
         },
       },
        series: seriesObj,
      };


      const echartsdom = document.getElementById('mychartI')
      this.mychartsI = echarts.init(echartsdom)

      this.mychartsI.setOption(option, true);// 渲染页面
    },
    initEchartsC(){
      const colors = [
        {
          'left': 'rgba(234, 162, 57, .16)',
          'right': 'rgba(234, 162, 57, .6)',
          'top': 'rgba(234, 162, 57, 1)',
          'bottom': 'rgba(234, 162, 57, .46)',
          'front': 'rgba(234, 162, 57, .66)',
        },
        {
          'left': 'rgba(63, 198, 139, .16)',
          'right': 'rgba(63, 198, 139, .6)',
          'top': 'rgba(63, 198, 139, 1)',
          'bottom': 'rgba(63, 198, 139, .46)',
          'front': 'rgba(63, 198, 139, .66)',
        },
        {
          'left': 'rgba(14, 252, 255, .16)',
          'right': 'rgba(14, 252, 255, .6)',
          'top': 'rgba(14, 252, 255, 1)',
          'bottom': 'rgba(14, 252, 255,  .46)',
          'front': 'rgba(14, 252, 255, .66)',
        },
        {
          'left': 'rgba(175, 111, 255, .16)',
          'right': 'rgba(175, 111, 255, .6)',
          'top': 'rgba(175, 111, 255, 1)',
          'bottom': 'rgba(175, 111, 255, .46)',
          'front': 'rgba(175, 111, 255, .66)',
        }
      ]

// 修改数据值，去掉"其他"
      const valueList = [13, 25, 50, 20];  // 总代、一代、集成商、终端

// 注册5个面图形:左侧、前面、右面、上面、下面
      const CubeLeft_1 = echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0
        },
        buildPath: function (ctx, shape) {
          const xAxisPoint = shape.xAxisPoint;
          const offsetX = Math.min(25, shape.height * 0.25);
          const offsetY = Math.min(18, shape.height * 0.18);

          const c0 = [shape.x - offsetX, shape.y];
          const c1 = [shape.x - 3, shape.y - offsetY];
          const c2 = [xAxisPoint[0] - 3, xAxisPoint[1] - offsetY];
          const c3 = [xAxisPoint[0] - offsetX, xAxisPoint[1]];
          ctx.moveTo(c0[0], c0[1])
              .lineTo(c1[0], c1[1])
              .lineTo(c2[0], c2[1])
              .lineTo(c3[0], c3[1])
              .closePath()
        }
      });

      const CubeFront_1 = echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0
        },
        buildPath: function (ctx, shape) {
          const xAxisPoint = shape.xAxisPoint;
          const offsetX = Math.min(25, shape.height * 0.25);

          const c0 = [shape.x - offsetX, shape.y];
          const c1 = [shape.x + 25, shape.y];
          const c2 = [xAxisPoint[0] + 25, xAxisPoint[1]];
          const c3 = [xAxisPoint[0] - offsetX, xAxisPoint[1]];
          ctx.moveTo(c0[0], c0[1])
              .lineTo(c1[0], c1[1])
              .lineTo(c2[0], c2[1])
              .lineTo(c3[0], c3[1])
              .closePath()
        }
      });

      const CubeRight_1 = echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0
        },
        buildPath: function (ctx, shape) {
          const xAxisPoint = shape.xAxisPoint;
          const offsetX = Math.min(25, shape.height * 0.25);
          const offsetY = Math.min(18, shape.height * 0.18);

          const c0 = [shape.x + 25, shape.y];
          const c1 = [shape.x + 25 + offsetX, shape.y - offsetY];
          const c2 = [xAxisPoint[0] + 25 + offsetX, xAxisPoint[1] - offsetY];
          const c3 = [xAxisPoint[0] + 25, xAxisPoint[1]];
          ctx.moveTo(c0[0], c0[1])
              .lineTo(c1[0], c1[1])
              .lineTo(c2[0], c2[1])
              .lineTo(c3[0], c3[1])
              .closePath()
        }
      });

      const CubeTop_1 = echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0
        },
        buildPath: function (ctx, shape) {
          const offsetX = Math.min(25, shape.height * 0.25);
          const offsetY = Math.min(18, shape.height * 0.18);

          const c0 = [shape.x - offsetX, shape.y];
          const c1 = [shape.x + 25, shape.y];
          const c2 = [shape.x + 25 + offsetX, shape.y - offsetY];
          const c3 = [shape.x - 3, shape.y - offsetY];
          ctx.moveTo(c0[0], c0[1])
              .lineTo(c1[0], c1[1])
              .lineTo(c2[0], c2[1])
              .lineTo(c3[0], c3[1])
              .closePath()
        }
      });

      const CubeBottom_1 = echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0
        },
        buildPath: function (ctx, shape) {
          const xAxisPoint = shape.xAxisPoint;
          const offsetX = Math.min(25, shape.height * 0.25);
          const offsetY = Math.min(18, shape.height * 0.18);

          const c0 = [xAxisPoint[0] - offsetX, xAxisPoint[1]];
          const c1 = [xAxisPoint[0] + 25, xAxisPoint[1]];
          const c2 = [xAxisPoint[0] + 25 + offsetX, xAxisPoint[1] - offsetY];
          const c3 = [xAxisPoint[0] - 3, xAxisPoint[1] - offsetY];

          ctx.moveTo(c0[0], c0[1])
              .lineTo(c1[0], c1[1])
              .lineTo(c2[0], c2[1])
              .lineTo(c3[0], c3[1])
              .closePath()
        }
      });

      echarts.graphic.registerShape('CubeLeft_1', CubeLeft_1)
      echarts.graphic.registerShape('CubeFront_1', CubeFront_1)
      echarts.graphic.registerShape('CubeRight_1', CubeRight_1)
      echarts.graphic.registerShape('CubeTop_1', CubeTop_1)
      echarts.graphic.registerShape('CubeBottom_1', CubeBottom_1)

     let option = {
        backgroundColor: 'transparent',  // 去掉背景色，改为透明
        // 添加标题
        title: {
          text: '客户数量',
          left: 'center',
          top: 10,
          textStyle: {
            color: '#fff',
            fontSize: 18,
            fontWeight: 'bold'
          }
        },
        grid: {
          left: '8%',
          right: '8%',
          bottom: '12%',
          top: '18%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['总代', '一代', '集成商', '终端'],  // 去掉"其他"
          axisLine: {
            show: false,
          },
          offset: 10,
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: '#fff',
            fontSize: 14,
            fontWeight: 'bold',
            margin: 15
          },
        },
        yAxis: {
          min: 0,
          max: 100,
          interval: 20,
          type: 'value',
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, .16)'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: 'rgba(255, 255, 255, .16)'
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            fontSize: 12,
            color: '#fff'
          },
        },
        series: [
          {
            type: 'custom',
            renderItem: (params, api) => {
              const location = api.coord([api.value(0), api.value(1)])
              const height = api.size([0, api.value(1)])[1];
              const value = api.value(1);  // 获取当前数值

              return {
                type: 'group',
                children: [
                  {
                    type: 'CubeBottom_1',
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      height: height,
                      xAxisPoint: api.coord([api.value(0), 0])
                    },
                    style: {
                      fill: colors[params.dataIndexInside]['bottom']
                    }
                  },
                  {
                    type: 'CubeLeft_1',
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      height: height,
                      xAxisPoint: api.coord([api.value(0), 0])
                    },
                    style: {
                      fill: colors[params.dataIndexInside]['left']
                    }
                  },
                  {
                    type: 'CubeFront_1',
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      height: height,
                      xAxisPoint: api.coord([api.value(0), 0])
                    },
                    style: {
                      fill: colors[params.dataIndexInside]['front']
                    }
                  },
                  {
                    type: 'CubeRight_1',
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      height: height,
                      xAxisPoint: api.coord([api.value(0), 0])
                    },
                    style: {
                      fill: colors[params.dataIndexInside]['right']
                    }
                  },
                  {
                    type: 'CubeTop_1',
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      height: height,
                      xAxisPoint: api.coord([api.value(0), 0])
                    },
                    style: {
                      fill: colors[params.dataIndexInside]['top']
                    }
                  },
                  // 添加数值标签
                  {
                    type: 'text',
                    style: {
                      x: location[0] + 20,  // 调整位置使其居中
                      y: location[1]-30,  // 在柱子上方显示
                      text: value + '个',
                      fill: '#fff',
                      font: 'bold 14px "Microsoft YaHei", sans-serif',
                      textAlign: 'center',
                      textBaseline: 'bottom'
                    },
                    styleEmphasis: {
                      fill: '#fff'
                    }
                  }
                ]
              }
            },
            data: valueList
          }
        ]
      }

      const echartsdom = document.getElementById('mychartC')
      this.mychartsC = echarts.init(echartsdom)

      this.mychartsC.setOption(option, true);// 渲染页面
    },

    initEchartsB() {

      echarts.registerMap('china', chinaGeoJson)
      const points = [
        { value: [116.405285, 39.904989] },
        { value: [113.54909, 22.198951] },
        { value: [91.132212, 29.660361]},
        { value: [126.642464, 45.756967] },
        { value: [87.617733, 43.792818] },
      ]
     let option = {
        "visualMap": [
          {
            "seriesIndex": [3],
            "show": false,
            "color": [
              "#FF324A",
              "#FCB136",
              "#F8E71C"
            ],
            "min": 0,
            "max": 550
          },
          {
            "seriesIndex": [4],
            "show": false,
            "color": [
              "#1A0AEE",
              "#18FF74",
              "#F8E71C"
            ],
            "min": 0,
            "max": 700
          },
          //   {
          //    "seriesIndex": [0],
          //    "show": false,
          //    "min": 0,
          //    "max": 120,
          //       color: ['rgba(255, 69, 0, 1)','rgba(255, 215, 0, 1)','rgba(0, 206, 209, 1)']
          //   }
        ],
        geo: [
          {
            map: 'china',
            roam: true, // 是否开启放大缩小/拖拽功能
            zoom: 1, // 缩放比列

            layoutCenter: ['50%', '50%'], // 地图中心点位置
            layoutSize: '100%',
            "z": 4,
            label: {
              show: true,
              color: '#fff'
            },
            itemStyle: {
              areaColor: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: 'rgba(17,21,31, 0.5)' // 0% 处的颜色
                }, {
                  offset: 1, color: 'rgba(241,92,92,0.24)' // 100% 处的颜色
                }],
                global: true // 缺省为 false
              },
              borderColor: '#2ab8ff',
              borderWidth: .5,
              shadowColor: 'rgba(0,54,255, 0.4)',

            },
            emphasis: { //区域激活时的样式
              itemStyle: {
                areaColor: 'rgba(2,16,43,0.6)',
              },
              label: {
                color: "#fff"
              }
            }
          },



        ],
        series: [


          {// 添加迁移线数据
            type: 'lines',
            "z": 4,
            data: [ // 配置多个点的数据
              {
                coords: [
                  [116.405285, 39.904989],
                  [113.54909, 22.198951],
                ]
              },
              {
                coords: [
                  [116.405285, 39.904989],
                  [91.132212, 29.660361],
                ]
              },
              {
                coords: [
                  [116.405285, 39.904989],
                  [126.642464, 45.756967]
                ]
              },
              {
                coords: [
                  [116.405285, 39.904989],
                  [87.617733, 43.792818]
                ]
              }
            ],
            effect: {
              show: true,
              period: 5, //箭头指向速度，值越小速度越快
              trailLength: 0.2, //特效尾迹长度[0,1]值越大，尾迹越长重
              symbol: 'pin', //箭头图标
              symbolSize: 10, //图标大小
              color:'#FFFF00'
            },
            lineStyle: {
              normal: {
                color:'rgba(255,232,136,0.3)',
                width: 1, //尾迹线条宽度
                opacity:.7, //尾迹线条透明度
                curveness: .3, //尾迹线条曲直度
              },
            },
          },
          { // 带有涟漪特效动画的散点（气泡）图
            type: 'effectScatter',
            coordinateSystem: 'geo',
            "z": 4,
            showEffectOn: 'render',
            zlevel: 1,
            rippleEffect: {
              color: '#FFD709',
              number: 3, // 波纹的数量。
              period: 5, // 动画的周期，秒数。
              scale: 17, // 动画中波纹的最大缩放比例。
              brushType: 'fill', // 波纹的绘制方式，可选 'stroke' 和 'fill'。
            },
            symbolSize: 2,
            data: points,
          },



        ],
       title: {
         text: '总出库:98200件   总入库:95000件    总销售:95000件',           // 标题文本
         left: 'center',             // 水平居中
         top: '4%',                  // 距离顶部距离
         textStyle: {
           color: '#fff',            // 标题颜色
           fontSize: 19,             // 标题字体大小
           fontWeight: 'bold',       // 字体加粗
         },
       },
      };

      const echartsdom = document.getElementById('mychartB')

      this.mychartsB = echarts.init(echartsdom)

      this.mychartsB.setOption(option, true);// 渲染页面
    },
    initEchartsF(){
// 科技感柱状图配置
    let  option = {

        // 标题
        title: {
          text: '本月供货数量',
          left: 'center',
          top: 20,
          textStyle: {
            color: '#fff',
            fontSize: 24,
            fontWeight: 'bold',
            fontFamily: 'Arial',
            textShadow: '0 0 20px rgba(0,255,255,0.8)'
          }
        },

        // 网格配置
        grid: {
          left: '8%',
          right: '5%',
          bottom: '15%',
          top: '20%',
          containLabel: true,
          borderColor: 'rgba(0, 255, 255, 0.3)',
          borderWidth: 1,
          backgroundColor: 'rgba(0, 20, 40, 0.3)'
        },

        // 提示框
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            shadowStyle: {
              color: 'rgba(0, 255, 255, 0.2)'
            }
          },
          borderColor: '#00ffff',
          borderWidth: 1,
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
          formatter: '{b}<br/>{c} 个单位'
        },

        // X轴
      xAxis: {
        type: 'category',
        data: ['枪机', '球机', '半球', 'ukey', '解码器', '一体化平台'],
        axisLine: {
          show: true,
          lineStyle: {
            color: '#00ffff',
            width: 2,
            type: 'solid',
            shadowColor: 'rgba(0, 255, 255, 0.8)',
            shadowBlur: 10,
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          show: true,
          color: '#fff',
          fontSize: 12,
          fontWeight: 'bold',
          margin: 10,
          interval: 0,  // 添加这一行，强制显示所有标签
          textShadow: '0 0 5px rgba(0,255,255,0.5)'
        },
        splitLine: {
          show: false
        }
      },

        // Y轴
        yAxis: {
          type: 'value',
          name: '数量',
          nameTextStyle: {

            fontSize: 14,
            fontWeight: 'bold',
            textShadow: '0 0 5px rgba(0,255,255,0.5)'
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#00ffff',
              width: 2,
              shadowColor: 'rgba(0, 255, 255, 0.8)',
              shadowBlur: 10
            }
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: '#00ffff'
            }
          },
          axisLabel: {
            color: '#fff',
            fontSize: 11,
            textShadow: '0 0 5px rgba(0,255,255,0.3)'
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(0, 255, 255, 0.15)',
              type: 'dashed',
              width: 1
            }
          }
        },

        // 数据系列
        series: [
          {
            name: '客户数量',
            type: 'bar',
            data: [65, 53, 47, 42, 38, 29],

            // 柱状图样式
            itemStyle: {
              color: function(params) {
                // 渐变颜色数组
                const colors = [
                  ['#00ffff', '#0066ff'], // 青色
                  ['#ff00ff', '#9900ff'], // 紫色
                  ['#ffff00', '#ff9900'], // 金色
                  ['#00ff99', '#00ccff'], // 绿色
                  ['#ff6600', '#ff00cc'], // 橙色
                  ['#9966ff', '#3300ff']  // 蓝色
                ];
                return {
                  type: 'linear',
                  x: 0, y: 0,
                  x2: 0, y2: 1,
                  colorStops: [
                    { offset: 0, color: colors[params.dataIndex % colors.length][0] },
                    { offset: 0.5, color: colors[params.dataIndex % colors.length][1] },
                    { offset: 1, color: colors[params.dataIndex % colors.length][0] }
                  ],
                  global: false
                };
              },
              borderRadius: [10, 10, 0, 0], // 顶部圆角

              // 发光效果
              shadowColor: 'rgba(0, 255, 255, 0.8)',
              shadowBlur: 15,
              shadowOffsetY: 5,

              // 边框
              borderColor: '#00ffff',
              borderWidth: 1,
              borderType: 'solid'
            },

            // 柱状图宽度
            barWidth: 35,
            barGap: '30%',

            // 标签（显示数值）
            label: {
              show: true,
              position: 'top',
              color: '#fff',
              fontSize: 12,
              fontWeight: 'bold',
              offset: [0, 10],
              textShadow: '0 0 10px #00ffff',
              formatter: '{c} 个'
            },

            // 背景层（增加科技感）
            backgroundStyle: {
              color: 'rgba(0, 255, 255, 0.05)',
              borderRadius: [10, 10, 0, 0]
            },

            // 动画效果
            animation: true,
            animationDuration: 2000,
            animationEasing: 'elasticOut',
            animationDelay: function(idx) {
              return idx * 200;
            }
          },

          // 添加数据点（增加细节）
          {
            type: 'scatter',
            data: [65, 53, 47, 42, 38, 29],
            coordinateSystem: 'cartesian2d',
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              color: '#ffffff',
              shadowColor: 'rgba(0, 255, 255, 0.8)',
              shadowBlur: 10,
              borderColor: '#00ffff',
              borderWidth: 1
            },
            label: {
              show: false
            },
            xAxisIndex: 0,
            yAxisIndex: 0
          }
        ],

        // 背景装饰
        graphic: [

        ],

        // 数据缩放
        dataZoom: [
          {
            type: 'slider',
            show: true,
            bottom: 5,
            height: 20,
            borderColor: 'transparent',
            backgroundColor: 'rgba(0, 255, 255, 0.1)',
            fillerColor: 'rgba(0, 255, 255, 0.2)',
            handleStyle: {
              color: '#00ffff',
              shadowColor: 'rgba(0, 255, 255, 0.8)',
              shadowBlur: 10
            },
            textStyle: {
              color: '#fff'
            }
          }
        ]
      };
      const echartsdom = document.getElementById('mychartF')

      this.mychartsF = echarts.init(echartsdom)

      this.mychartsF.setOption(option, true);// 渲染页面
    }
  },
}
</script>
<style scoped>
.dashboard {
  height: 100vh;
  width: 100vw;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
}

.dashboard::after {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(10, 15, 35, 0.65);
  z-index: 0;
}

.grid-container {
  position: relative;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-rows: 1fr 3fr 3fr 3fr;
  grid-template-columns: 3fr 4fr 3fr;
  gap: 16px;
  padding: 10px;
  box-sizing: border-box;
}

.grid-item {
  background: rgba(30, 40, 70, 0.6);
  border-radius: 12px;
  border: 1px solid rgba(100, 120, 255, 0.25);
  color: #e0e0ff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}

/* Header 专用样式 */
.header-content {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title {
  font-size: 38px;
  margin: 0;
  text-align: center;
  flex: 1;
}

.header-icons {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  gap: 16px;
}

.icon-btn {
  background: rgba(80, 100, 180, 0.5);
  border: 1px solid rgba(140, 160, 255, 0.4);
  border-radius: 8px;
  color: #d0e0ff;
  font-size: 24px;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.icon-btn:hover {
  background: rgba(100, 130, 220, 0.7);
  transform: scale(1.08);
}

/* Dialog 样式 */
.dialog-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-content {
  background: rgba(30, 40, 80, 0.95);
  border-radius: 12px;
  padding: 28px 36px;
  width: 90%;
  max-width: 460px;
  border: 1px solid rgba(120, 150, 255, 0.4);
  color: #e0e0ff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}

.dialog-content h3 {
  margin: 0 0 16px 0;
  font-size: 1.5rem;
}

.dialog-actions {
  margin-top: 24px;
  display: flex;
  gap: 16px;
  justify-content: flex-end;
}

.dialog-actions button {
  padding: 8px 20px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
}

.dialog-actions button:first-child {
  background: #444;
  color: white;
}

.dialog-actions button:last-child {
  background: #5a7cff;
  color: white;
}
</style>